import { useCallback } from 'react';
import { QueryFilters } from '@tanstack/react-query';
import { invalidateQueries } from '../utils/query-client-methods';

/**
 * @deprecated use {@link invalidateQueries `invalidateQueries`}
 */
export function useInvalidateQueries(queryFilters?: QueryFilters) {
  return useCallback(() => {
    invalidateQueries(queryFilters);
  }, [queryFilters]);
}
